
export const Addtask = ({edit, setEdit, task, setTask, tasklist, setTasklist}) => {


    const handleSubmit = (e) => {
        e.preventDefault();
        
        setEdit(false);
        
        if (task.id){ 
            const updatedTask = tasklist.map((item) => item.id === task.id ? {...item, name: e.target.task.value} : item);
            setTasklist(updatedTask);
            setTask([]);
            e.target.task.value = '';
            localStorage.setItem('tasklist', JSON.stringify(updatedTask));

        } else {
        const val = e.target.task.value;
        if (val === '') return;
        const newTask = {
            id : new Date().getTime(),
            name: val,
            date: new Date().toLocaleString()
        }
        setTasklist([...tasklist, newTask]);

        const data = localStorage.getItem('tasklist');
        if (data){
            localStorage.setItem('tasklist', JSON.stringify([...JSON.parse(data), newTask]));
        }

        setTask([]);
        e.target.task.value = '';
        }

        
    }

  return (
    <section className="flex flex-row justify-center items-center p-4 bg-gray-200 w-full mx-auto m-2 rounded-lg md:w-full">
       
     
      
        <form onSubmit={handleSubmit}>
            <input 
            type="text" 
            name="task" 
            placeholder="Add Task" 
            value={task.name ? task.name : ''}  
            className="p-2 border border-gray-800 rounded-lg text-black"
            onChange={(e)=> setTask({...task, name : e.target.value}) } />
            <button className="p-2 bg-blue-800 text-white rounded-lg ">{edit ? "Edit" : "Add"}</button>
            
        </form>

       </section>
  )
}
